import getOr from 'lodash/fp/getOr';
import noop from 'lodash/fp/noop';

import classNames from 'classnames';

import PropTypes from 'prop-types';

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import DeliverableEditorForm from '~/features/artifacts/components/DeliverableEditorForm';
import {
    changeDeliverableEditor,
    createDeliverable,
    updateDeliverable,
} from '~/features/artifacts/actions/deliverableActions';
import {
    deliverableEditorSelector,
    deliverablesContextsSelector,
    deliverableTypeSelector,
} from '~/features/artifacts/selectors/deliverableSelectors';
import { DELIVERABLE_SCHEMA } from '~/features/deliverables/constants/deliverablesParameters';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import Spinner from '@rio-cloud/rio-uikit/Spinner';

/**
 * Deliverable editor dialog
 */
export class DeliverableEditorDialog extends PureComponent {

    onSaveDeliverable = () => {
        const { model, deliverableType } = this.props;

        // if (!this.isValid(model)) {
        //     return;
        // }
        if (model.isNew) {
            const newDeliverable = {
                'context': model.context,
                'deliverableName': model.deliverableName,
                'schema': DELIVERABLE_SCHEMA,
                'type': deliverableType,
                'file': model.file,
            };
            this.props.createDeliverable(newDeliverable);
        } else {
            this.props.updateDeliverable(model);
        }
    };

    isValid(model) {
        return !!model.deliverableName;
    }

    render() {
        const { model, contexts, match } = this.props;
        const title = this.renderTitle(model);
        const body = this.renderBody(model, contexts);
        const footer = this.renderFooter(model);
        return (
            <Dialog className='file-deliverable-editor-dialog'
                    show={true}
                    showCloseButton={true}
                    onClose={this.props.hideModal}
                    title={title}
                    body={body}
                    footer={footer}
                    useOverflow
            />
        );
    }

    renderTitle(model) {
        const isNew = getOr(true, 'isNew', model);
        if (isNew) {
            return <FormattedMessage id='intl-msg:createDeliverable'/>;
        }
        return <FormattedMessage id='intl-msg:editDeliverable.title' values={{
            deliverableName: model.deliverableName,
        }}/>;
    }

    renderBody(model, contexts) {
        return (
            <DeliverableEditorForm model={model}
                                   contexts={contexts}
                                   changeDeliverableEditor={this.props.changeDeliverableEditor}/>
        );
    }

    renderFooter(model) {
        const isValid = true;
        const isInProgress = getOr(false, 'isInProgress', model);

        const isReady = isValid && !isInProgress;
        return (
            <div className='btn-toolbar justify-content-end'>
                <button className='btn btn-default' onClick={this.props.hideModal}>
                    <FormattedMessage id='intl-msg:close'/>
                </button>
                <button className={classNames('btn btn-primary', { disabled: !isReady })}
                        onClick={this.onSaveDeliverable}>
                    {
                        isInProgress ?
                            <Spinner text={<FormattedMessage id='intl-msg:save'/>}/> :
                            <FormattedMessage id='intl-msg:save'/>
                    }
                </button>
            </div>
        );
    }
}

export const mapStateToProps = (state) => {
    return {
        deliverableType: deliverableTypeSelector(state),
        model: deliverableEditorSelector(state),
        contexts: deliverablesContextsSelector(state),
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        createDeliverable: (newDeliverable) => {
            dispatch(createDeliverable(newDeliverable));
        },
        updateDeliverable: (softwareVersion) => {
            dispatch(updateDeliverable(softwareVersion));
        },
        changeDeliverableEditor: payload => {
            dispatch(changeDeliverableEditor(payload));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliverableEditorDialog);

DeliverableEditorDialog.defaultProps = {
    // props
    model: {},
    contexts: [],
    // functions
    createDeliverable: noop,
    updateDeliverable: noop,
    changeDeliverableEditor: noop,
};

DeliverableEditorDialog.propTypes = {
    // props
    model: PropTypes.object,
    contexts: PropTypes.array,
    // functions
    createDeliverable: PropTypes.func,
    updateDeliverable: PropTypes.func,
    changeDeliverableEditor: PropTypes.func,
};
